import { render, staticRenderFns } from "./ReceivedRewardsTimelineItem.vue?vue&type=template&id=a87d325c&scoped=true&"
import script from "./ReceivedRewardsTimelineItem.vue?vue&type=script&lang=js&"
export * from "./ReceivedRewardsTimelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87d325c",
  null
  
)

export default component.exports